import {
  DispatchStopPickupPopupInfo,
  DispatchUnassignedPickupPopupInfo,
} from "../../../../../mapComponents/Popups";
import {
  getPickupStopData,
  getMarkerComponent,
  isPickupDriverExistInGrid,
  isDelayStop,
} from "../utils";

const PickupPopupInfo = ({
  theme,
  specialNeeds,
  routesData,
  selectedPickup,
  showAction = false,
  enableChangePickupTerminal=false,
  terminal,
  routesList,
  currentActiveRoutes,
  unAssignDriver = "",
  openMessageChatBox = "",
  onRecommendationsButtonClick = "",
  terminalCodeList = [],
  glEventHub = "",
}) => {
  const { offset, code } = terminal;
  const stopData = getPickupStopData(routesList, selectedPickup).stopData;
  const hideTerminalChange =
    selectedPickup.isCompleted ||
    selectedPickup.isVoided ||
    !enableChangePickupTerminal;
  const commonProps = {
    theme: theme.themeName,
    hideAction: !showAction,
    specialNeeds,
  };
  return (
    <>
      {selectedPickup.driverId &&
      isPickupDriverExistInGrid({
        currentActiveRoutes,
        driverId: selectedPickup.driverId,
        routeId: selectedPickup.routeId,
      }) ? (
        <DispatchStopPickupPopupInfo
          {...commonProps}
          stopData={stopData}
          unAssignDriver={unAssignDriver}
          pickupNumber={selectedPickup.pickupNumber}
          isDelayStop={isDelayStop(stopData)}
          routesData={routesData}
          terminalOffset={offset}
          openDriverChat={openMessageChatBox}
        />
      ) : (
        <DispatchUnassignedPickupPopupInfo
          {...commonProps}
          onButtonClicked={onRecommendationsButtonClick}
          data={{ data: selectedPickup }}
          hideTerminalChange={hideTerminalChange}
          terminalOptions={terminalCodeList}
          activeTerminal={code}
          glEventHub={glEventHub}
          markerComponent={getMarkerComponent({
            terminalOffset: offset,
            pickup: selectedPickup,
            theme,
          })}
        />
      )}
    </>
  );
};

export default PickupPopupInfo;
